import CardsList from "@/components/cardsList";
import { PlainHoverEffect } from "styles/hoverPresets";
import { USE_CASES_CONSTANTS } from "./constants";

const UseCasesComp = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 3 }}
      title={USE_CASES_CONSTANTS.title}
      list={USE_CASES_CONSTANTS.list}
      spacing={{ base: 8, md: 16 }}
      hoverEffect
      hover={PlainHoverEffect}
    />
  );
};

export default UseCasesComp;
